import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAccount } from 'app/store/models/account.model';
import { IListApiModel } from 'app/store/models/api.model';
import { ICorrectionParams, IReferralPartner } from 'app/store/models/franchisee.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FranchiseeService {

  constructor(
    private readonly httpClient: HttpClient
  ) { }

  listFranchisees(): Observable<IListApiModel<IAccount>> {
    return this.httpClient.get<IListApiModel<IAccount>>(`${environment.apiUrl}/v1/users`, {
      params: {
        user_type: 'franchisee'
      }
    });
  }

  listReferralPartners(): Observable<IListApiModel<IReferralPartner>> {
    return this.httpClient.get<IListApiModel<IReferralPartner>>(`${environment.apiUrl}/v1/referralpartners`);
  }

  createReferralPartner(data: {name: string, contact_email: string, franchisee_id: number}): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/referralpartners`, data);
  }

  updateReferralPartner(id: number, data: {name: string, contact_email: string, franchisee_id: number, company_name: string, address: string, details: string, notes: string}): Observable<any> {
    return this.httpClient.put(`${environment.apiUrl}/v1/referralpartners/${id}`, data);
  }

  approveReferralPartner(id: number): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/referralpartners/${id}/approve`, {});
  }

  resendOnboardingEmail(id: number): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/referralpartners/${id}/resend-onboarding`, {});
  }

  approveDeal(id: number): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/deals/${id}/approve`, {});
  }

  updateDeal(id: number, data: {franchisee_share: string, referral_partner_share: string, notes: string, effective_from: string, effective_until: string}): Observable<any> {
    return this.httpClient.put(`${environment.apiUrl}/v1/deals/${id}`, data);
  }

 registerReferral(data: any): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/referralpartners/confirm`, data);
  }

  viewReferralPartnerByConfirmationToken(token: string): Observable<IReferralPartner> {
    return this.httpClient.get<IReferralPartner>(`${environment.apiUrl}/v1/referralpartners/${token}`);
  }

  updateFranchiseeAttribute(accountId: number, attribute: string, value: any): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/franchisee/${accountId}/attribute`, {
      [attribute]: value
    });
  }

  exportRevenueLadger(params: any, format: string): Observable<any> {
    return this.httpClient.get(`${environment.apiUrl}/v1/admin/revenue-reports`, {
      params: {
        ...params,
        export: format
      },
      responseType: 'blob' as 'json'
    });
  }

  disburseRevenueLadger(id: number[]): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/revenueledger/disburse`, {
      entry_ids: id
    });
  }

  correction(id: number, data: ICorrectionParams): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/v1/revenueledger/${id}/correction`, data);
  }

}
